export enum SortBy {
    OrderStatus,
    OrderNumber,
    ExpectedReadyTime,
    ExpectedDeliveryTime,
    PatientName,
    ReferenceNumber,
    TripStatus,
    TripNumber,
    Driver,
    Dispatcher,
    DispatchDate,
    SpecialInstructions,
    PhoneNumber,
    DeliveryAddress,
    OrderCount,
    TotalPlannedMileage,
    TotalDuration
}

export enum ViewAsTypes {
    Tiles = "Tiles",
    Table = "Table",
    NestedTable = "NestedTable"
}